export default "__VITE_ASSET__D2OIc_TT__"